const initialState = {
  teams: [
    {
      id: "1",
      initials: "PCH",
      name: "Przemysław Chmielewski",
      specialize: "Psychiatra",
      description:
        "Specjalista lekarz psychiatra, w Centrum Terapii prowadzi konsultacje diagnostyczne i terapeutyczne dla osób dorosłych.",
      tags: [
        "psychiatria",
        "konsultacje dorosłych",
        "diagnostyka",
        "leczenie zaburzeń psychicznych",
      ],
      image: null,
    },
    {
      id: "2",
      initials: "MR",
      name: "Marta Roczkowska",
      specialize: "Psycholog, psychoterapeutka systemowa",
      description:
        "Absolwentka psychologii na Uniwersytecie Jagiellońskim, psychoterapeutka certyfikowana przez Polskie Towarzystwo Psychiatryczne (nr 787). Ukończyła Szkolenie Podyplomowe „Systemowe rozumienie rodziny: podejście systemowe w terapii rodzin” oraz Całościowe Szkolenie Podyplomowe atestowane przez Sekcję Naukową Psychoterapii i Terapii Rodzin Polskiego Towarzystwa Psychiatrycznego. Specjalizuje się w terapii systemowej rodzin i terapii par.",
      tags: [
        "psychoterapia systemowa",
        "terapia par",
        "terapia rodzin",
        "superwizja",
        "psychologia kliniczna",
      ],
      image: null,
    },

    {
      id: "3",
      initials: "JSZ",
      name: "Jolanta Szczucińska",
      specialize: "Psycholog, psychoterapeutka Gestalt",
      description:
        "Psycholog i psychoterapeuta Gestalt, ukończyła studia o kierunku Psychologia Stosowana na Uniwersytecie Jagiellońskim oraz 4-letni całościowy kurs psychoterapii w Instytucie Integralnej Psychoterapii Gestalt (IIPG) w Krakowie, jest certyfikowanym psychoterapeutą Gestalt (cert. nr 9) oraz formalnym członkiem Europejskiego Stowarzyszenia Terapii Gestalt (EAGT), a także certyfikowanym psychoterapeutą Gestalt w Polskim Towarzystwie Psychoterapii Gestalt (cert. nr 101/2014). Doświadczenie zawodowe zdobywała pracując w poradniach zdrowia psychicznego dla osób dorosłych, dzieci oraz młodzieży, od prawie dekady współpracuje z placówkami oświatowymi. W Centrum Terapii pracuje indywidualnie z młodzieżą oraz osobami dorosłymi.",
      tags: [
        "psychoterapia Gestalt",
        "psychologia stosowana",
        "terapia dorosłych",
        "terapia młodzieży",
      ],
      image: null,
    },

    {
      id: "4",
      initials: "AP",
      name: "Anna Paluch",
      specialize: "Psycholog, psychoonkolog, psychoterapeuta psychodynamiczny",
      description:
        "Absolwentka psychologii ogólnej na Uniwersytecie Jagiellońskim, psychoonkolog, psychoterapeuta w nurcie psychodynamicznym w trakcie certyfikacji Polskiego Towarzystwa Psychiatrycznego, uczestniczka kursu psychoterapii dzieci i młodzieży w Szpitalu im.dr J.Babińskiego w Krakowie, w Centrum zajmuje się diagnozą i psychoterapią młodzieży oraz osób dorosłych, a także wsparciem dla osób chorujących onkologicznie i ich rodzin.",
      tags: [
        // 'terapia',
        "psychoterapia psychodynamiczna",
        "psychoonkologia",
        "terapia dorosłych",
        "terapia młodzieży",
        "superwizja",
      ],
      image: null,
    },

    {
      id: "5",
      initials: "NK",
      name: "Natalia Korbut",
      specialize: "Psycholog",
      description:
        "Absolwentka psychologii na Uniwersytecie Komisji Edukacji Narodowej w Krakowie, zajmuje się diagnozą i wsparciem psychologicznym osób dorosłych, w swojej pracy interesuje się pomocą osobom w kryzysach psychicznych, wsparciem odporności psychicznej ",
      tags: [
        "psychologia dzieci i dorosłych",
        "wsparcie w kryzysach",
        "psychologia rozwojowa",
        "odporność psychiczna",
        "wsparcie rodziców",
      ],
      image: null,
    },

    {
      id: "6",
      initials: "KP",
      name: "Katarzyna Podstawa-Pyka",
      specialize: "Psycholog, psychoterapeutka systemowo-psychodynamiczna",
      description:
        "Absolwentka Psychologii Stosowanej na Uniwersytecie Jagiellońskim, ukończyła 4-letni całościowy kurs psychoterapii w Ośrodku Szkoleń Systemowych w Krakowie. Stale bierze udział w szkoleniach i konferencjach podnosząc swój warsztat pracy, w której łączy nurt systemowy z psychodynamicznym. ",
      tags: [
        "psychoterapia psychodynamiczna",
        "psychoterapia systemowa",
        "terapia dzieci",
        "terapia młodzieży",
        "psychologia stosowana",
      ],
      image: null,
    },

    {
      id: "7",
      initials: "MS",
      name: "Monika Sudek",
      specialize: "Pedagog, terapeuta SI, logopeda, neurologopeda ",
      description:
        "Doświadczony nauczyciel edukacji przedszkolnej i wczesnoszkolnej z wieloletnim stażem pracy z dziećmi. Swoją pasję do wspierania najmłodszych rozwija także jako terapeuta integracji sensorycznej, terapeuta ręki oraz logopeda i neurologopeda. Stale poszerza swoją wiedzę i umiejętności, a praca z dziećmi daje jej ogromną satysfakcję.",
      tags: [
        "integracja sensoryczna",
        "SI",
        "logopedia",
        "neurologopedia",
        "terapia dzieci",
        "terapia ręki",
        "pedagogika wczesnoszkolna",
      ],
      image: null,
    },

    {
      id: "8",
      initials: "AO",
      name: "Agnieszka Ozga-Kaczmarska",
      specialize:
        "Psycholog, psychoterapeutka psychodynamiczna, interwent kryzysowy",
      description:
        "Psycholog i psychoterapeutka psychodynamiczna, wspierająca dorosłych w kryzysach życiowych oraz zaburzeniach lękowych i depresyjnych. Pracuje także z osobami z niepełnosprawnościami, oferując bezpieczną i wspierającą przestrzeń do rozmowy, zrozumienia emocji oraz wypracowania skutecznych strategii radzenia sobie w trudnych sytuacjach.",
      tags: [
        "psychoterapia psychodynamiczna",
        "interwencja kryzysowa",
        "wsparcie dorosłych",
        "lęk",
        "depresja",
        "niepełnosprawność",
      ],
      image: null,
    },

    {
      id: "9",
      initials: "KB",
      name: "Katarzyna Bielarczyk ",
      specialize: "Psychoterapeutka systemowo-psychodynamiczna",
      description:
        "Psychoterapeutka w trakcie ostatniego roku całościowego, 5-letniego szkolenia w nurcie systemowo-psychodynamicznym. Absolwentka kierunku nauki o rodzinie ze specjalizacją w poradnictwie i mediacjach rodzinnych. Przez 8 lat pracowała jako kurator społeczny wspierając rodziny i młodzież w sytuacjach kryzysowych. Od 2015 roku związana ze Szpitalem Specjalistycznym im. dr J. Babińskiego w Krakowie, gdzie zdobywa doświadczenie kliniczne. Prowadzi psychoterapię indywidualną dorosłych oraz terapię par i rodzin.",
      tags: [
        "psychoterapia systemowo-psychodynamiczna",
        "terapia dorosłych",
        "terapia par",
        "terapia rodzin",
        "kryzys",
        "doświadczenie kliniczne",
      ],
      image: null,
    },
    {
      id: "10",
      initials: "KK",
      name: "Katarzyna Kwaśny  ",
      specialize: "Psychoterapeutka poznawczo-behawioralna",
      description:
        "Absolwentka psychologii o specjalności kliniczno-sądowej z przygotowaniem pedagogicznym do pracy z dziećmi. Doświadczenie zdobywała w poradni psychologiczno-pedagogicznej, przedszkolach terapeutycznych i integracyjnych oraz w Oddziale Klinicznym Psychiatrii Dzieci i Młodzieży. Ukończyła szkolenie z zakresu psychoterapii dzieci i młodzieży w nurcie poznawczo-behawioralnym. Pracuje z dziećmi z wyzwaniami rozwojowymi, prowadzi terapię indywidualną oraz zajęcia rozwijające kompetencje społeczno-emocjonalne. Wspiera także rodziców poprzez konsultacje i psychoedukację.",
      tags: [
        "psychologia dzieci i młodzieży",
        "terapia dzieci",
        "kompetencje społeczno-emocjonalne",
        "wsparcie rodziców",
        "psychoedukacja",
        "podejście poznawczo-behawioralne",
      ],
      image: null,
    },
    {
      id: "11",
      initials: "MR",
      name: "Maria Rusin",
      specialize:
        "Pedagog, Terapeuta integracji sensorycznej, Oligofrenopedagog",
      description:
        "Specjalizuje się w pracy z dziećmi o zróżnicowanych potrzebach rozwojowych i edukacyjnych. W swojej pracy łączy kompetencje pedagogiczne z terapią integracji sensorycznej, wspierając rozwój, samodzielność i poczucie własnej wartości dziecka. Szczególną wagę przywiązuje do budowania bezpiecznej, opartej na zaufaniu relacji z podopiecznym, wierząc, że dobra więź jest fundamentem skutecznej terapii i nauki.",
      tags: [
        "integracja sensoryczna",
        "terapia SI",
        "oligofrenopedagogika",
        "wsparcie rozwoju dziecka",
        "dzieci ze specjalnymi potrzebami",
        "terapia pedagogiczna",
      ],
      image: null,
    },
    {
      id: "12",
      initials: "JM",
      name: "Justyna Mucharska",
      specialize: "Psycholog",
      description:
        " Absolwentka psychologii na Uniwersytecie SWPS, posiada przygotowanie pedagogiczne do pracy z dziećmi i młodzieżą. W swojej pracy wykorzystuje założenia Terapii Skoncentrowanej na Rozwiązaniach oraz elementy podejścia poznawczo-behawioralnego. Prowadzi konsultacje psychologiczne dla młodzieży od 14. roku życia oraz osób dorosłych. Wspiera młodzież doświadczającą trudności rówieśniczych, a także osoby mierzące się z kryzysami życiowymi, trudnościami emocjonalnymi i problemami w relacjach. ",
      tags: [
        "konsultacje psychologiczne",
        "młodzież 14+",
        "wsparcie dorosłych",
        "Terapia Skoncentrowana na Rozwiązaniach",
        "podejście poznawczo-behawioralne",
        "kryzys życiowy",
        "trudności emocjonalne",
      ],
      image: null,
    },
    {
      id: "13",
      initials: "MS",
      name: "Monika Solarz",
      specialize: "Psycholog",
      description:
        "Magister psychologii stosowanej Uniwersytetu Jagiellońskiego, w trakcie 5-letniego kursu psychoterapii systemowej w Krakowskiej Fundacji Rozwoju Psychoterapii. Doświadczenie zawodowe zdobywa w domu pomocy społecznej dla osób przewlekle chorujących psychicznie oraz w Centrum Terapii Motus, gdzie pracuje głównie z młodzieżą. W ramach projektów realizuje Treningi Umiejętności Społecznych (TUS) dla osób z niepełnosprawnościami. Doświadczenie zdobywała również w Dziennym Oddziale Psychiatryczno-Rehabilitacyjnym, Centrum Wsparcia i Terapii Osób Niepełnosprawnych i Ich Rodzin oraz placówce wsparcia dziennego, prowadząc terapię psychologiczną dzieci z niepełnosprawnościami, w spektrum autyzmu oraz terapię biofeedback.",
      tags: [
        "psychoterapia systemowa",
        "młodzież",
        "Trening Umiejętności Społecznych (TUS)",
        "niepełnosprawność",
        "spektrum autyzmu",
        "wsparcie psychologiczne",
      ],
      image: null,
    },
  ],

  offers: [
    {
      id: "1",

      title: "Poradnia Psychologiczna",
      description: "",
      services: [],
    },
    {
      id: "2",

      title: "Poradnia Psychologiczna dla Dzieci i Młodzieży",
      description: "",
      services: [],
    },
    {
      id: "3",

      title: "Poradnia Zdrowia Psychicznego dla Dorosłych",
      description: ".",
      services: [],
    },
    {
      id: "4",

      title: "Poradnia Logopedyczna dla Dzieci",
      description: "",
      services: [],
    },
  ],
};

export default initialState;
